import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable, of, ReplaySubject, tap} from 'rxjs';
import { User } from 'app/core/user/user.types';

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private observableUser: Observable<any> | null;
    private userSaved: any = null;
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User)
    {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User>
    {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User>
    {
        return this._httpClient.get<User>('api/auth/logged-user').pipe(
            tap((user) => {
                this._user.next(user);
            })
        );
    }

    /**
     * Get logged user + cached
     */
    public profile(): Observable<any> {
        if (this.userSaved) {
            return of (this.userSaved);
        } else if (this.observableUser) {
            return this.observableUser;
        } else {
            this.observableUser = this.get().pipe(
                map((user: any) => {
                    return this.userSaved = user;
                })
            );
            return this.observableUser;
        }
    }

    public getReservations(id: string): Observable<any>{
        return this._httpClient.get<{}>(`api/reservation/users/${id}`).pipe();
    }

    public getCountries(): Observable<any>{
        return this._httpClient.get<{}>(`api/classifiers`).pipe();
    }

    public clearLoggedUserCache(){
        this.userSaved = null;
        this.observableUser = null;
        this.profile();
    }


}
